import type { ReactNode } from 'react';

interface CycleSavedBannerProps {
  cycleNumber: number;
  savedCount: number;
  children: ReactNode;
}

/** Green banner shown after saving products in a cycle. */
export default function CycleSavedBanner({
  cycleNumber,
  savedCount,
  children,
}: CycleSavedBannerProps) {
  return (
    <div className="mb-6">
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <p className="text-green-700 font-semibold mb-3">
          {savedCount} product(s) saved in Cycle {cycleNumber}
        </p>
        <div className="flex flex-wrap gap-2">{children}</div>
      </div>
    </div>
  );
}
